const ActionTypes = {
  ADD_EPFFORM2_NOMINEE_DETAILS: "ADD_EPFFORM2_NOMINEE_DETAILS",
  ADD_GRATUITY_NOMINEE_DETAILS: "ADD_GRATUITY_NOMINEE_DETAILS",
  ADD_RELATION_DETAILS: "ADD_RELATION_DETAILS",
  DELETE_EPFFORM2_NOMINEE_DETAILS: "DELETE_EPFFORM2_NOMINEE_DETAILS",
  DELETE_GRATUITY_NOMINEE_DETAILS: "DELETE_GRATUITY_NOMINEE_DETAILS",
  DELETE_RELATION_DETAILS: "DELETE_RELATION_DETAILS",
  GET_PERSONAL_DETAILS: "GET_PERSONAL_DETAILS",
  GET_RELATIONSHIP_LIST: "GET_RELATIONSHIP_LIST",
  UPDATE_NOMINEE_DETAILS: "UPDATE_NOMINEE_DETAILS",
  UPDATE_PERSONAL_DETAILS: "UPDATE_PERSONAL_DETAILS",
  UPDATE_OTHER_BANK_DETAILS: "UPDATE_OTHER_BANK_DETAILS"
};
export default ActionTypes;
